import { datadogRum } from '@datadog/browser-rum';

import config from 'config';

export function initRUM(sessionId: string): typeof datadogRum | undefined {
  if (!JSON.parse(config.DD_RUM_ENABLED || 'false')) {
    return undefined;
  }

  datadogRum.init({
    applicationId: 'c12fcb6a-28df-45f9-baef-5c5ce4e93e15',
    clientToken: 'puba2254a1ac7e85577a452dbc373c1332a',
    site: 'datadoghq.com',
    service: config.APP_NAME,
    env: config.PARTNERS_ENVIRONMENT,
    version: config.REACT_APP_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    allowedTracingUrls: [config.PARTNERS_SELF_SIGNUP_BFF_URL].map(
      origin => new RegExp(origin),
    ),
    beforeSend: event => {
      // Filter out ResizeObserver errors
      // https://gympass.atlassian.net/browse/PAREXP-308
      if (
        event.type === 'error' &&
        event.error?.message?.includes(
          'ResizeObserver loop completed with undelivered notifications.',
        )
      ) {
        return false;
      }

      return true;
    },
    enableExperimentalFeatures: ['feature_flags'],
  });

  datadogRum.setUser({
    id: sessionId,
  });

  datadogRum.startSessionReplayRecording();

  return datadogRum;
}
